import { cohortBuilderEmptyStateCardMessagesEn } from './cohort-builder-cards/cohortBuilderEmptyStateCardMessagesEn';
import { cohortBuilderSqlContentMessagesEn } from './cohort-builder-cards/cohortBuilderSqlContentMessagesEn';
import { cohortBuilderViewCardMessagesEn } from './cohort-builder-cards/cohortBuilderViewCardMessagesEn';
import { cohortBuilderHeaderMessagesEn } from './cohort-section-messages/cohortBuilderHeaderMessagesEn';
import { criteriaSectionMessagesEn } from './cohort-section-messages/criteriaSectionMessagesEn';
import { derivedEventsSectionMessagesEn } from './cohort-section-messages/derivedEventsSectionMessagesEn';
import { dslTranslationsSectionMessagesEn } from './cohort-section-messages/dslTranslationsSectionMessagesEn';
import { indexDateSectionMessagesEn } from './cohort-section-messages/indexDateSectionMessagesEn';
import { researchAssistantSectionMessageEn } from './cohort-section-messages/researchAssistantSectionMessageEn';
import { simpleEventsSectionMessageEn } from './cohort-section-messages/simpleEventsSectionMessageEn';
import { studyPeriodSectionMessagesEn } from './cohort-section-messages/studyPeriodSectionMessagesEn';
import { subjectVariablesSectionMessagesEn } from './cohort-section-messages/subjectVariablesSectionMessagesEn';
import { cohortBuilderInfoBarMessagesEn } from './components/cohortBuilderInfoBarMessagesEn';

export default {
  ...cohortBuilderHeaderMessagesEn,

  ...cohortBuilderEmptyStateCardMessagesEn,
  ...cohortBuilderViewCardMessagesEn,
  ...cohortBuilderSqlContentMessagesEn,

  ...simpleEventsSectionMessageEn,
  ...derivedEventsSectionMessagesEn,

  ...studyPeriodSectionMessagesEn,
  ...indexDateSectionMessagesEn,
  ...subjectVariablesSectionMessagesEn,
  ...criteriaSectionMessagesEn,
  ...dslTranslationsSectionMessagesEn,

  ...cohortBuilderInfoBarMessagesEn,

  ...researchAssistantSectionMessageEn,
};
